import { memo } from '@fantastic-utils/memo';

const memoPadZero = memo((str, len = 2) => {
  str = String(str);
  return str.padStart(len, '0');
});

export function contrastText(hex, bw = null) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    
    hex = hex.slice(0, 6);

    if (hex.length !== 6)
        throw new Error('Invalid HEX color.');
    
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        return (r * 0.299 + g * 0.587 + b * 0.114) > 130
            ? '#000000'
            : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + memoPadZero(r) + memoPadZero(g) + memoPadZero(b);
}